import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ApploadService } from '@app/services/appload.service';
import { CommonHelper } from '@app/shared/helpers/common.helper';

import SwiperCore, { Navigation, Pagination, Scrollbar } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar]);

@Component({
  selector: 'assetswiperControl',
  templateUrl: './assetswiper-control.component.html',
  styleUrls: ['./assetswiper-control.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AssetSwiperControlComponent implements OnInit {

  @Input() modelAssets: any[];
  @Input() isClose: boolean = true;
  @Input() enableRemoveBtn: boolean = false;
  @Output() highlightedToParent = new EventEmitter<any>();
  @Output() primaryFlagToParent = new EventEmitter<any>();
  @Output() assetRemovalToParent = new EventEmitter<any>();

  constructor(private _cmHelper: CommonHelper, public _apploadService: ApploadService,) { }

  ngOnInit(): void { 
    this._apploadService.setEquipmentValue(this.modelAssets);
  }

  filterItemsOfActive() {
    return this.modelAssets.filter(x => !x.isDelete);
  }
  assetPanelHighlight(selected: any) {
    this.highlightedToParent.emit(selected);
  }
  assetPanelPrimaryFlag(selected: any) {
    this.primaryFlagToParent.emit(selected);
  }
  assetPanelRemoval(selected: any) {
    this.assetRemovalToParent.emit(selected);
  }
  getMileageDisplayValue(input_measure){
    return this._cmHelper.getMileageDisplayValue(input_measure);
  }

}
